<template>
  <div
    class="IsoChatGroup"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.IsoChatGroup {
  position: absolute;
  top: 0;
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: clamp(220px, 58vw, 320px); // todo
}
</style>
